// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
$(document).on('ready', function() {
    Popup.mount();
});

$(document).on('shopify:section:select', function(e) {

    var $section = $(e.target);

    if ($section.hasClass('mount-popup')) {
        Popup._show();
    }
});

$(document).on('shopify:section:deselect', function(e) {

    var $section = $(e.target);

    if ($section.hasClass('mount-popup')) {
        Popup._hide();
    }


});


$(document).on('shopify:section:load', function(e) {

    var $section = $(e.target);

    if ($section.hasClass('mount-popup')) {
        Popup.mount();
    }

});




var Popup = {

    $popup: null,

    mount: function() {

        this.$popup = $('#shopify-section-popup');

        var show = this.$popup.find('.popup-content').data('show'),
            freq = this.$popup.find('.popup-content').data('freq'),
            enable = this.$popup.find('.popup-content').data('enable');

        if (show > 0 && enable) {
            setTimeout((function() {
                this._trigger(show, freq);
            }).bind(this), parseInt(show * 1000));
        }

        this.$popup.find('.site-close-handle').on('click', (function(e) {
            this._hide();
        }).bind(this));

        this.$popup.find('.popup-background').on('click', (function(e) {
            this._hide();
        }).bind(this));

    },

    _show: function() {
        this.$popup.addClass('active');
    },

    _hide: function() {
        this.$popup.removeClass('active');
    },

    _trigger: function(show, freq) {

        var popupKey = 'popup-' + document.location.hostname,
            popupStorage = localStorage.getItem(popupKey) != null ? JSON.parse(localStorage.getItem(popupKey)) : null;

        if (popupStorage != null) {

            if (popupStorage['show'] != show || popupStorage['freq'] != freq) {

                this._refreshStorage(popupKey, show, freq);;

                // user saw the ad but settings are different - show it!
                this._show();

            } else {

                // user saw the ad so we need to check if he should see it again

                if (freq == 'every') {

                    if (sessionStorage[popupKey] == null || sessionStorage[popupKey] != 'shown') {
                        this._show();
                        this._refreshStorage(popupKey, show, freq);;
                    }

                } else {

                    var shownAt = popupStorage['shown'],
                        nowAt = new Date().getTime(),
                        inBetween = Math.round((nowAt - shownAt) / 1000);

                    if (freq == 'day' && inBetween > 129600) {
                        this._show();
                        this._refreshStorage(popupKey, show, freq);;
                    } else if (freq == 'week' && inBetween > 907200) {
                        this._show();
                        this._refreshStorage(popupKey, show, freq);;
                    }

                }

            }

        } else {

            this._refreshStorage(popupKey, show, freq);

            // user never saw the ad - show it!

            this._show();

        }

    },

    _refreshStorage: function(popupKey, show, freq) {

        localStorage.setItem(popupKey, JSON.stringify({
            'show': show,
            'freq': freq,
            'shown': new Date().getTime()
        }));

        sessionStorage[popupKey] = 'shown';

    },

    unmount: function() {}

}
